(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primerry-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('primerry-announcement')) {
    customElements.define('primerry-announcement', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.primerry-announcement__pause');
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        }; 
        this.button?.addEventListener('click', this.onToggle);
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primerry-rotating-banner"] && !Shopify.designMode) return;
  try {
    
  class PrimerryRotatingBanner extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.slides = Array.from(this.querySelectorAll('[data-rotation-slide]'));
      this.bottles = Array.from(this.querySelectorAll('[data-rotation-bottle]'));
      this.wheel = this.querySelector('[data-rotation-wheel]');
      this.button = this.querySelector('.primerry-rotation__button');
      this.status = this.querySelector('[data-rotation-status]');
      this.count = this.slides.length;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.position = this.index;
      this.duration = Number(this.dataset.transitionDuration) || 700;
      this.interval = Number(this.dataset.interval) || 4000;
      this.clickRotate = this.dataset.clickRotate === 'true';
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.animating = false;
      this.inView = true;
      this.hoverPaused = false;
      this.focusPaused = false;
      this.editorPaused = false;

      this.onClick = () => {
        if (!this.clickRotate || this.count < 2) return;
        this.next();
      };
      // Only a real mouse pauses on hover. Touch taps fire emulated mouse events
      // with no matching "leave", which used to stop auto-rotate for good on mobile.
      this.onPointerEnter = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hoverPaused = true;
        this.stopTimer();
      };
      this.onPointerLeave = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hoverPaused = false;
        this.startTimer();
      };
      // Pause for keyboard focus only. A mouse click also focuses the button,
      // which used to stop auto-rotate after the first click.
      this.onFocusIn = (event) => {
        if (!this.isKeyboardFocus(event.target)) return;
        this.focusPaused = true;
        this.stopTimer();
      };
      this.onFocusOut = (event) => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.startTimer();
      };
      this.onVisibilityChange = () => (document.hidden ? this.stopTimer() : this.startTimer());
      this.onBlockSelect = (event) => {
        const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (selected < 0) return;
        this.editorPaused = true;
        this.stopTimer();
        this.goTo(selected, true);
      };
      this.onBlockDeselect = () => {
        this.editorPaused = false;
        this.startTimer();
      };

      this.button?.addEventListener('click', this.onClick);
      if (this.pauseOnHover) {
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
      }
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          this.inView = entry.isIntersecting;
          this.inView ? this.startTimer() : this.stopTimer();
        }, { threshold: 0.15 });
        this.observer.observe(this);

        // Load every bottle before the wheel first turns, so nothing pops in mid-move.
        this.preloadObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.preloadBottles();
        }, { rootMargin: '600px 0px' });
        this.preloadObserver.observe(this);
      } else {
        this.preloadBottles();
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.measure();
          this.renderWheel();
        });
        this.resizeObserver.observe(this);
      }

      this.measure();
      this.renderWheel();
      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.cancelWheelAnimation();
      this.button?.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.observer?.disconnect();
      this.preloadObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }

    isKeyboardFocus(target) {
      try {
        return Boolean(target?.matches(':focus-visible'));
      } catch (error) {
        return false;
      }
    }

    preloadBottles() {
      this.bottles.forEach((bottle) => {
        const image = bottle.querySelector('img');
        if (image && image.loading === 'lazy') image.loading = 'eager';
      });
      this.preloadObserver?.disconnect();
    }

    measure() {
      if (!this.wheel || !this.bottles.length) return;
      const styles = getComputedStyle(this.wheel);
      const read = (name, fallback) => {
        const value = parseFloat(styles.getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      };
      const width = this.wheel.clientWidth || this.clientWidth;
      const unit = Math.min(width / read('--wheel-base', 1441), 1);
      const angle = (read('--wheel-angle', 24) * Math.PI) / 180;
      const spread = Math.max(width / 2 - read('--wheel-x', 144) * unit, 1);

      this.geometry = {
        angle,
        centerX: width / 2,
        centerY: read('--wheel-y', 330) * unit + spread / Math.tan(angle),
        radius: spread / Math.sin(angle),
        bottleWidth: this.bottles[0].offsetWidth,
        bottleHeight: this.bottles[0].offsetHeight,
        fadeStart: read('--wheel-fade-start', 0.6),
        fadeLength: Math.max(read('--wheel-fade-length', 0.4), 0.01),
      };
    }

    // Places every bottle for the current wheel position. Slot n rests on the
    // left when position === n and on the right when position === n - 1.
    renderWheel() {
      const geometry = this.geometry;
      if (!geometry || !geometry.bottleWidth) return;
      const total = this.bottles.length;
      const half = total / 2;

      this.bottles.forEach((bottle, slot) => {
        let offset = slot - this.position;
        if (this.count > 1) offset = ((((offset + half) % total) + total) % total) - half;

        const overshoot = offset < 0 ? -offset : offset > 1 ? offset - 1 : 0;
        const opacity = overshoot > geometry.fadeStart
          ? Math.max(0, 1 - (overshoot - geometry.fadeStart) / geometry.fadeLength)
          : 1;

        if (opacity <= 0) {
          bottle.style.visibility = 'hidden';
          bottle.style.opacity = '0';
          return;
        }

        const angle = geometry.angle * (2 * offset - 1);
        const x = geometry.centerX + geometry.radius * Math.sin(angle) - geometry.bottleWidth / 2;
        const y = geometry.centerY - geometry.radius * Math.cos(angle) - geometry.bottleHeight / 2;

        bottle.style.visibility = 'visible';
        bottle.style.opacity = opacity >= 1 ? '1' : opacity.toFixed(3);
        bottle.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0) rotate(${((angle * 180) / Math.PI).toFixed(3)}deg)`;
      });
    }

    animateWheel(from, to, onComplete) {
      this.cancelWheelAnimation();
      const start = performance.now();
      const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

      const step = (now) => {
        const progress = Math.min(1, (now - start) / this.duration);
        this.position = from + (to - from) * ease(progress);
        this.renderWheel();

        if (progress < 1) {
          this.frame = window.requestAnimationFrame(step);
        } else {
          this.frame = null;
          onComplete();
        }
      };

      this.frame = window.requestAnimationFrame(step);
    }

    cancelWheelAnimation() {
      if (!this.frame) return;
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    normalizePosition() {
      const total = this.bottles.length;
      if (!total) return;
      this.position = ((Math.round(this.position) % total) + total) % total;
    }

    next() {
      if (this.animating || this.count < 2) return;
      this.goTo(this.index + 1, false);
    }

    goTo(targetIndex, immediate = false) {
      if (!this.count) return;
      const nextIndex = ((targetIndex % this.count) + this.count) % this.count;
      if (nextIndex === this.index) return;

      const current = this.slides[this.index];
      const next = this.slides[nextIndex];
      const steps = (nextIndex - this.index + this.count) % this.count;
      let from = Math.round(this.position);
      from -= (((from - this.index) % this.count) + this.count) % this.count;
      const to = from + steps;
      this.stopTimer();

      if (immediate || this.reducedMotion) {
        this.cancelWheelAnimation();
        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === nextIndex);
          slide.classList.remove('is-entering', 'is-leaving');
          slide.setAttribute('aria-hidden', index === nextIndex ? 'false' : 'true');
        });
        this.index = nextIndex;
        this.position = nextIndex;
        this.renderWheel();
        this.style.setProperty('--rotation-background', next.dataset.background);
        this.animating = false;
        this.announce(next);
        this.startTimer();
        return;
      }

      this.animating = true;
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-entering');
      next.setAttribute('aria-hidden', 'false');
      this.style.setProperty('--rotation-background', next.dataset.background);

      this.animateWheel(from, to, () => {
        current.classList.remove('is-leaving');
        next.classList.remove('is-entering');
        next.classList.add('is-active');
        this.index = nextIndex;
        this.normalizePosition();
        this.renderWheel();
        this.animating = false;
        this.announce(next);
        this.startTimer();
      });
    }

    announce(slide) {
      if (this.status) this.status.textContent = slide.dataset.title || '';
    }

    canAutoRotate() {
      return (
        this.autoRotate &&
        !this.reducedMotion &&
        this.count > 1 &&
        this.inView &&
        !document.hidden &&
        !this.hoverPaused &&
        !this.focusPaused &&
        !this.editorPaused
      );
    }

    startTimer() {
      if (!this.canAutoRotate() || this.timer || this.animating) return;
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.next();
      }, this.interval);
    }

    stopTimer() {
      if (!this.timer) return;
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('primerry-rotating-banner')) {
    customElements.define('primerry-rotating-banner', PrimerryRotatingBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
